export namespace ApiUrl {
    export const ROOT = '/api';
    export namespace Auth {
        const RESOURCES = `${ROOT}/auth`;
        export const AUTHENTICATE = `${RESOURCES}/authenticate`;
        export const LOGOUT = `${RESOURCES}/logout`;
        export const AUTHORITIES = `${RESOURCES}/authorities`;
        export const HARD_DEVICE_REGISTER = `${RESOURCES}/hardware_token_register`;
        export const SOFT_DEVICE_REGISTER = `${RESOURCES}/google_authenticator_register`;
        export const SEND_UNLOCK_MAIL = `${RESOURCES}/send_unlock_mail`;
        export const SEND_PASSWORD_RESET_MAIL = `${RESOURCES}/send_password_reset_mail`;
        export const SEND_UNCONFIRMED_MAIL = `${RESOURCES}/send_unconfirmed_mail`;
        export const UPDATE_FORGOTTEN_PASSWORD_PATH = `${RESOURCES}/update_forgotten_password`;
    }
    export namespace Saml {
        const RESOURCES = `${ROOT}/saml`;
        export const SSO = `${RESOURCES}/sso`;
    }
    export namespace User {
        const RESOURCES = `${ROOT}/users`;
        export const SEARCH = `${RESOURCES}/search`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const UNLOCK = `${RESOURCES}/unlock`;
        export const EXPIRE = `${RESOURCES}/:id/expire`;
        export const IMPORT = `${RESOURCES}/import`;
        export const IMPORT_IDP = `${RESOURCES}/import_idp`;
        export const UPDATE_PASSWORD = `${RESOURCES}/:id/update_password`;
        export const MULTIFACTOR_AUTHENTICATION_ENABLED = `${RESOURCES}/:id/multifactor_authentication_enabled`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
        export const PERSONAL_SETTINGS = `${RESOURCES}/personal_settings`;
        export const ACCESS_KEYS = `${RESOURCES}/:user_id/access_keys`;
        export const UPDATE_ACCESS_KEYS = `${RESOURCES}/:user_id/access_keys/:id`;
        export const GATEWAY_SETTING = `${RESOURCES}/gateway_connection_button_information`;
        export const SSH_CONNECT = `${RESOURCES}/ssh`;
        export const RDP_DOWNLOAD = `${RESOURCES}/rdp`;
        export const SESSION_TOKEN = `${RESOURCES}/session_token`;
        export namespace ApplicationFormWorkAccount {
            const RESOURCES1 = `${RESOURCES}/:user_id/application_form_work_accounts`;
            export const CURRENT_SAML = `${RESOURCES1}/current_saml`;
            export const CURRENT_SAML_SKIP = `${RESOURCES1}/current_saml/skip`;
        }
    }
    export namespace UserGroup {
        const RESOURCES = `${ROOT}/user_groups`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const ADD_USERS = `${RESOURCES}/:id/add_users`;
        export const REMOVE_USERS = `${RESOURCES}/:id/remove_users`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace NodeDomain {
        const RESOURCES = `${ROOT}/node_domains`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const CONNECTION = `${RESOURCES}/connection`;
        export const ACCOUNT = `${RESOURCES}/account`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
        export const RANDOMIZABLE_ACCOUNTS = `${RESOURCES}/:id/randomizable_accounts`;
    }
    export namespace DomainAccount {
        const RESOURCES = `${ROOT}/domain_accounts`;
        export const SEARCH = `${RESOURCES}/search`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}`;
        export const CONNECTION = `${RESOURCES}/connection`;
        export const ACCOUNT = `${RESOURCES}/account`;
    }
    export namespace NodeIdp {
        const RESOURCES = `${ROOT}/node_idps`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const CONNECTION = `${RESOURCES}/connection`;
        export const ACCOUNT = `${RESOURCES}/account`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace IdpAccount {
        const RESOURCES = `${ROOT}/idp_accounts`;
        export const SEARCH = `${RESOURCES}/search`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}`;
        export const ACCOUNT = `${RESOURCES}/account`;
    }
    export namespace IdpTypes {
        const RESOURCES = `${ROOT}/idp_types`;
        export const INDEX = `${RESOURCES}`;
    }
    export namespace Node {
        const RESOURCES = `${ROOT}/nodes`;
        export const SEARCH = `${RESOURCES}/search`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const OS_CONNECTION = `${RESOURCES}/os_connection`;
        export const OS_CONNECTION_AFTER_CREATED = `${RESOURCES}/:id/os_connection`;
        export const DOMAIN_CONNECTION = `${RESOURCES}/domain_connection`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
        export const ADD_APPS = `${RESOURCES}/:id/add_auto_login_apps`;
        export const REMOVE_APPS = `${RESOURCES}/:id/remove_auto_login_apps`;
        export const ADD_EXCLUDES = `${RESOURCES}/:id/add_node_login_history_exclude_conditions`;
        export const REMOVE_EXCLUDES = `${RESOURCES}/:id/remove_node_login_history_exclude_conditions`;
        export const RANDOMIZABLE_ACCOUNTS = `${RESOURCES}/:id/randomizable_accounts`;
        export const SAML_NODES_SEARCH = `${RESOURCES}/saml_service_provider`;
        export const SAML_CERTIFICATE_DOWNLOAD = `${RESOURCES}/:id/saml_certificate_download`;
        export const SAML_CERTIFICATE_REISSUE = `${RESOURCES}/:id/saml_certificate_reissue`;
        export const SAML_METADATA_DOWNLOAD = `${RESOURCES}/:id/node_samls/metadata`;
        export const LOGIN_HISTORY_COLLECTION_INTERVAL_TYPE_ACQUISITION = `${RESOURCES}/login_history_collection_interval_type`;
        export namespace Account {
            const RESOURCES1 = `${RESOURCES}/:id/accounts`;
            export const SEARCH = `${RESOURCES1}/search`;
        }
        export namespace DomainAccount {
            const RESOURCES1 = `${RESOURCES}/:id/domain_accounts`;
            export const SEARCH = `${RESOURCES1}`;
            export const CREATE = `${RESOURCES1}`;
            export const DESTROY = `${RESOURCES1}`;
        }
        export namespace OsAccount {
            const RESOURCES1 = `${RESOURCES}/:id/os_accounts`;
            export const SEARCH = `${RESOURCES1}`;
            export const CREATE = `${RESOURCES1}`;
            export const SHOW = `${RESOURCES1}/:account_id`;
            export const UPDATE = `${RESOURCES1}/:account_id`;
            export const DESTROY = `${RESOURCES1}`;
            export const CONNECTION = `${RESOURCES1}/connection`;
        }
        export namespace OtherAccount {
            const RESOURCES1 = `${RESOURCES}/:id/other_accounts`;
            export const SEARCH = `${RESOURCES1}`;
            export const CREATE = `${RESOURCES1}`;
            export const SHOW = `${RESOURCES1}/:account_id`;
            export const UPDATE = `${RESOURCES1}/:account_id`;
            export const DESTROY = `${RESOURCES1}`;
            export const CONNECTION = `${RESOURCES1}/connection`;
        }
        export namespace IdpAccount {
            const RESOURCES1 = `${RESOURCES}/:id/idp_accounts`;
            export const SEARCH = `${RESOURCES1}`;
            export const CREATE = `${RESOURCES1}`;
            export const DESTROY = `${RESOURCES1}`;
        }
        export namespace AutoLoginApp {
            const RESOURCES1 = `${RESOURCES}/:id/auto_login_apps`;
            export const SEARCH = `${RESOURCES1}`;
            export const CREATE = `${RESOURCES1}`;
            export const DESTROY = `${RESOURCES1}`;
        }
        export namespace NodeLoginHistoryExcludeCondition {
            const RESOURCES1 = `${RESOURCES}/:id/node_login_history_exclude_conditions`;
            export const INDEX = `${RESOURCES1}`;
            export const CREATE = `${RESOURCES1}`;
            export const DESTROY = `${RESOURCES1}`;
        }
    }
    export namespace NodeGroup {
        const RESOURCES = `${ROOT}/node_groups`;
        export const INDEX = `${RESOURCES}`;
        export const INDEX_SAML = `${RESOURCES}/saml_service_provider_node`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const ADD_NODES = `${RESOURCES}/:id/add_nodes`;
        export const REMOVE_NODES = `${RESOURCES}/:id/remove_nodes`;
        export const INDEX_ALL = `${RESOURCES}/all`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace NodeAccount {
        const RESOURCES = `${ROOT}/node_accounts`;
        export const INDEX = `${RESOURCES}`;
        export const MANUALLY_RANDOMIZE_PASSWORD_OR_SSH_KEY = `${RESOURCES}/manually_randomize_password_or_ssh_key`;
        export const RESERVABLE_FOR_WORK = `${RESOURCES}/reservable_for_work`;
    }
    export namespace NodeTypes {
        const RESOURCES = `${ROOT}/node_types`;
        export const NORMAL_NODE_INDEX = `${RESOURCES}/normal_node`;
        export const SIMPLE_NODE_INDEX = `${RESOURCES}/simple_node`;
    }
    export namespace UserSetting {
        const RESOURCES = `${ROOT}/user_settings`;
        export const SHOW = `${RESOURCES}`;
        export const UPDATE = `${RESOURCES}`;
        export const BEFORE_LOGIN = `${RESOURCES}/before_login`;
        export const CONNECTION = `${RESOURCES}/connection`;
        export const CONNECTION_IDP = `${RESOURCES}/connection_idp`;
    }
    export namespace MailSetting {
        const RESOURCES = `${ROOT}/mail_settings`;
        export const SHOW = `${RESOURCES}`;
        export const UPDATE = `${RESOURCES}`;
        export const CONNECTION = `${RESOURCES}/connection`;
    }
    export namespace MultifactorAuth {
        const RESOURCES = `${ROOT}/multifactor_authentications`;
        export const SEARCH = `${RESOURCES}/search`;
        export const HARD = `${RESOURCES}/hard`;
        export const SHOW = `${RESOURCES}/:id`;
        export const SWITCH_DEVICES = `${RESOURCES}/switch_devices`;
        export const RESET_TIME_CORRECTIONS = `${RESOURCES}/reset_time_corrections`;
        export const REMOVAL_USERS = `${RESOURCES}/removal_users`;
        export const DESTROY = `${RESOURCES}`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace SystemChangeHistory {
        const RESOURCES = `${ROOT}/system_change_histories`;
        export const USER = `${RESOURCES}/user`;
        export const MAIL = `${RESOURCES}/mail`;
        export const NODE = `${RESOURCES}/node`;
        export const JOB = `${RESOURCES}/job`;
        export const SYSTEM_SETTING = `${RESOURCES}/system_setting`;
        export const ACCOUNT_INVENTORY_SETTING = `${RESOURCES}/account_inventory_setting`;
        export const USER_OUTPUT = `${RESOURCES}/user_output`;
        export const MAIL_OUTPUT = `${RESOURCES}/mail_output`;
        export const NODE_OUTPUT = `${RESOURCES}/node_output`;
        export const JOB_OUTPUT = `${RESOURCES}/job_output`;
        export const SYSTEM_SETTING_OUTPUT = `${RESOURCES}/system_setting_output`;
        export const ACCOUNT_INVENTORY_SETTING_OUTPUT = `${RESOURCES}/account_inventory_setting_output`;
    }
    export namespace JobExecutionHistory {
        const RESOURCES = `${ROOT}/job_execution_histories`;
        export const SEARCH = `${RESOURCES}/search`;
        export const SEARCH_SELECT = `${RESOURCES}/search_select_box_items`;
        export const SHOW = `${RESOURCES}/:id`;
        export const RETRY = `${RESOURCES}/retry`;
        export const CANCEL = `${RESOURCES}/cancel`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace CsvList {
        const RESOURCES = `${ROOT}/csv`;
        export const SEARCH = `${RESOURCES}/search`;
        export const DOWNLOAD = `${RESOURCES}/:id/download`;
    }
    export namespace DetectionRule {
        const RESOURCES = `${ROOT}/detection_rules`;
        export const SEARCH = `${RESOURCES}/search`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace DetectionRuleGroup {
        const RESOURCES = `${ROOT}/detection_rule_groups`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const ADD_RULES = `${RESOURCES}/:id/add_detection_rules`;
        export const REMOVE_RULES = `${RESOURCES}/:id/remove_detection_rules`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace Workflow {
        const RESOURCES = `${ROOT}/workflows`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace BusinessSystem {
        const RESOURCES = `${ROOT}/business_systems`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export namespace ApplicationTemplate {
            const RESOURCES1 = `${RESOURCES}/:id/application_templates`;
            export const INDEX = `${RESOURCES1}`;
            export const CREATE = `${RESOURCES1}`;
            export const SHOW = `${RESOURCES1}/:template_id`;
            export const UPDATE = `${RESOURCES1}/:template_id`;
            export const DESTROY = `${RESOURCES1}/:template_id`;
        }
        export namespace AccountSet {
            const RESOURCES1 = `${RESOURCES}/:id/account_sets`;
            export const INDEX = `${RESOURCES1}`;
            export const CREATE = `${RESOURCES1}`;
            export const SHOW = `${RESOURCES1}/:account_set_id`;
            export const UPDATE = `${RESOURCES1}/:account_set_id`;
            export const CSV_OUTPUT = `${RESOURCES1}/csv`;
            export const DESTROY = `${RESOURCES1}/:account_set_id`;
        }
    }
    export namespace AutoLoginApp {
        const RESOURCES = `${ROOT}/auto_login_applications`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
        export const DOWNLOAD = `${RESOURCES}/:id/download`;
    }
    export namespace ApplicationFormNumber {
        const RESOURCES = `${ROOT}/application_form_number_formats`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const PREFIX_PREVIEW = `${RESOURCES}/prefix_preview`;
    }
    export namespace ApplicationFormTemplate {
        const RESOURCES = `${ROOT}/application_form_templates`;
        export const INDEX = `${RESOURCES}`;
        export const RESOURCES1 = `${RESOURCES}/:id`;
        export const BASE = `${RESOURCES1}/base`;
        export const CUSTOMIZE_FIELD = `${RESOURCES1}/customize_field`;
        export const BUSINESS = `${RESOURCES1}/business`;
        export const WORKER = `${RESOURCES1}/worker`;
        export const WORKFLOW = `${RESOURCES1}/workflow`;
        export const COUNT = `${RESOURCES}/count`;
    }
    export namespace ApplicationForm {
        const RESOURCES = `${ROOT}/application_forms`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const ACTION = `${RESOURCES}/action`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
        export const USER_ROLES = `${RESOURCES}/:id/user_roles`;
        export const EVENT_LOG = `${RESOURCES}/:id/event_logs`;
        export const WORK_LOG = `${RESOURCES}/:id/work_logs`;
        export const UPLOAD_FILE = `${RESOURCES}/:id/attachment_files`;
        export const DESTROY_FILE = `${ROOT}/attachment_files`;
        export const DOWNLOAD = `${ROOT}/attachment_files/:id/download`;
        export const PASSWORD_NOTIFICATION = `${RESOURCES}/:application_form_id/node_accounts/:id/password_notification`;
        export const NUMBER_PER_STATUS = `${RESOURCES}/number_per_status`;
        export const USABLE_ACTIONS = `${RESOURCES}/:id/usable_actions`;
        export const FILES = `${RESOURCES}/:id/files`;
        export const DETECTION_RULES = `${RESOURCES}/:id/detection_rules`;
        export const MAIL_DESTINATIONS = `${RESOURCES}/:id/mail_destinations`;
        export const TASK_INDEX = `${RESOURCES}/tasks`;
        export const TEMPLATE_CHECK_FOR_CONFIRMER = `${RESOURCES}/:id/template_check_for_confirmer`;
        export namespace PrivilegedIdLendingRecord {
            const RESOURCES1 = `${RESOURCES}/:id/privilege_id_lending_records`;
            export const INDEX = `${RESOURCES1}`;
        }
    }
    export namespace WaitingApplication {
        const RESOURCES = `${ROOT}/waiting_applications`;
        export const INDEX = `${RESOURCES}`;
        export const DESTROY = `${RESOURCES}`;
    }
    export namespace PrivilegedIdSetting {
        const RESOURCES = `${ROOT}/privileged_id_settings`;
        export const SHOW = `${RESOURCES}`;
        export const UPDATE = `${RESOURCES}`;
    }
    export namespace DetectionRulesRecord {
        const RESOURCES = `${ROOT}/detection_records`;
        export const SEARCH = `${RESOURCES}/search`;
        export const SHOW = `${RESOURCES}/:id/info`;
        export const LOG_FILE = `${RESOURCES}/:id/text`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace PrivilegeIdLendingRecord {
        const RESOURCES = `${ROOT}/privilege_id_lending_records`;
        export const SEARCH = `${RESOURCES}/search`;
        export const SHOW = `${RESOURCES}/:id`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
        export const MOVIE_FILE = `${RESOURCES}/:id/movie_file`;
        export const TEXT_FILE = `${RESOURCES}/:id/text_file`;
        export const REC_FILE = `${RESOURCES}/:id/rec_file`;
        export const COMMENT = `${RESOURCES}/:id/comment`;
        export const DISPLAYABLE = `${RESOURCES}/displayable`;
        export const REGISTER_LOGIN = `${RESOURCES}/:id/register_login`;
        export const ROUTINE_WORK = `${RESOURCES}/routine_work`;
    }
    export namespace ApplicationFormWorkAccounts {
        const RESOURCES = `${ROOT}/application_form_work_accounts`;
        export const PRIVILEGE_ID_LENDING_RECORDS = `${RESOURCES}/:id/privilege_id_lending_records`;
    }
    export namespace LoginRecord {
        const RESOURCES = `${ROOT}/login_records`;
        export const SEARCH = `${RESOURCES}/search`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
        export const REC_FILE = `${RESOURCES}/:id/rec_file`;
    }
    export namespace Dashboard {
        const RESOURCES = `${ROOT}/dashboards`;
        export const ALERT_INDEX = `${RESOURCES}/alerts`;
    }
    export namespace SystemSetting {
        const RESOURCES = `${ROOT}/settings`;
        export const SHOW = `${RESOURCES}`;
        export const UPDATE = `${RESOURCES}`;
    }
    export namespace FromAddressList {
        const RESOURCES = `${ROOT}/from_address_lists`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}`;
    }
    export namespace RecSetting {
        const RESOURCES = `${ROOT}/rec_settings`;
        export const SHOW = `${RESOURCES}`;
        export const UPDATE = `${RESOURCES}`;
    }
    export namespace License {
        const RESOURCES = `${ROOT}/licenses`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const ACTIVE = `${RESOURCES}/active`;
        export const CAPACITY = `${RESOURCES}/capacity`;
        export const ACTIVATE = `${RESOURCES}/:id/activate`;
        export const DESTROY = `${RESOURCES}/:id`;
    }
    export namespace Notices {
        const RESOURCES = `${ROOT}/notices`;
        export const NOTICES = `${RESOURCES}`;
    }
    export namespace ProductVersion {
        const RESOURCES = `${ROOT}/product_versions`;
        export const INDEX = `${RESOURCES}`;
    }
    export namespace ExternalProgramUsage {
        const RESOURCES = `${ROOT}/external_program_usages`;
        export const INDEX = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
        export const DOWNLOAD = `${RESOURCES}/:id/download`;
    }
    export namespace ExecutionTimingList {
        const RESOURCES = `${ROOT}/execution_timing_lists`;
        export const INDEX = `${RESOURCES}`;
    }
    export namespace LoginFailureRecord {
        const RESOURCES = `${ROOT}/login_failure_records`;
        export const SEARCH = `${RESOURCES}/search`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace LogonType {
        const RESOURCES = `${ROOT}/logon_types`;
        export const INDEX = `${RESOURCES}`;
    }
    export namespace NodeLoginHistoryExcludeCondition {
        const RESOURCES = `${ROOT}/node_login_history_exclude_conditions`;
        export const INDEX = `${RESOURCES}`;
        export const SEARCH = `${RESOURCES}/search`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const CSV_OUTPUT = `${RESOURCES}/csv`;
    }
    export namespace AccountInventoryResultDiff {
        const RESOURCES = `${ROOT}/account_inventory_result_diffs`;
        export const SEARCH = `${RESOURCES}/search`;
        export const SHOW = `${RESOURCES}/:id`;
        export const CHANGED_ACCOUNTS = `${RESOURCES}/:id/changed_accounts`;
        export const ADDED_ACCOUNTS = `${RESOURCES}/:id/added_accounts`;
        export const DELETED_ACCOUNTS = `${RESOURCES}/:id/deleted_accounts`;
        export const CSV_OUTPUT = `${RESOURCES}/:id/csv`;
    }
    export namespace AccountInventorySetting {
        const RESOURCES = `${ROOT}/account_inventory_settings`;
        export const SEARCH = `${RESOURCES}`;
        export const CREATE = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const UPDATE = `${RESOURCES}/:id`;
        export const EXECUTE_INVENTORY = `${RESOURCES}/:id/execute_inventory`;
        export const DESTROY = `${RESOURCES}/:id`;
        export const SEARCH_UNASSIGNED_NODE_GROUPS = `${RESOURCES}/:id/search_unassigned_node_groups`;
        export const ADD_NODE_GROUPS = `${RESOURCES}/:id/add_node_groups`;
        export const REMOVE_NODE_GROUPS = `${RESOURCES}/:id/remove_node_groups`;
        export const SEARCH_UNASSIGNED_NODE_DOMAINS = `${RESOURCES}/:id/search_unassigned_node_domains`;
        export const ADD_NODE_DOMAINS = `${RESOURCES}/:id/add_node_domains`;
        export const REMOVE_NODE_DOMAINS = `${RESOURCES}/:id/remove_node_domains`;
        export const UPDATE_SECURITY_GROUPS = `${RESOURCES}/:id/node_domains/:domain_id/update_security_groups`;
    }
    export namespace AccountInventoryResult {
        const RESOURCES = `${ROOT}/account_inventory_results`;
        export const SEARCH = `${RESOURCES}`;
        export const SHOW = `${RESOURCES}/:id`;
        export const NODE_ITEMS = `${RESOURCES}/:id/node_items`;
        export const DOMAIN_ITEMS = `${RESOURCES}/:id/domain_items`;
        export const DIFF = `${RESOURCES}/diff`;
        export const RETRY = `${RESOURCES}/:id/retry`;
        export const CSV_OUTPUT = `${RESOURCES}/:id/items/csv`;
    }
    export namespace NodeSaml {
        const RESOURCES = `${ROOT}/node_samls`;
        export const ACS_REDIRECT_DATA = `${RESOURCES}/sp/acs_redirect/`;
    }
    export namespace TimeZone {
        const RESOURCES = `${ROOT}/time_zone`;
        export const INDEX = `${RESOURCES}`;
    }
}

export default ApiUrl;
